import {ReactComponent as RuvitlLogo } from '../../icons/RUVITL.svg';
export default function RuvnlHeading({title}: {title: string}) {
    return (
        <div className="header flex items-center justify-between">
        <h1>{title}</h1>
        <div className='flex flex-row justify-center items-center space-x-2 '>
            {/* <RuvitlLogo width={"40px"} height={"60px"} /> */}
            <h1>Discom 1</h1></div>
        <h1 className='w-20'></h1>
      </div>
    )
}
export function RuvnlTitle() {
    return (
        <div className='flex flex-row justify-center items-center space-x-2 '>
            {/* <RuvitlLogo width={"40px"} height={"60px"} /> */}
            <h1>Demo</h1>
            </div>
    )
}

interface FooterProps {
    source: string;
    note: string;
  }
  
 export const GnaRuvnlFooter: React.FC<FooterProps> = ({ source, note }) => {
    return (
      <div className="gna-footer-container">
        <div className="flex justify-between">
          <p className="gna-footer-text">{source}</p>
          <p className="gna-footer-text">Powered by GNA Energy</p>
          {/* <p className="gna-footer-text">Beta Version</p> */}
        </div>
        <p className="gna-footer-note">{note}</p>
      </div>
    );
  };
  
  